import { Card } from "@/components/ui/card";
import { Badge } from "@/components/ui/badge";
import { CheckCircle, Clock, AlertCircle } from "lucide-react";
interface SymptomsRecapProps {
  answers: Record<string, any>;
}
const SymptomsRecap = ({
  answers
}: SymptomsRecapProps) => {
  const extractMainSymptoms = () => {
    const symptoms: string[] = [];

    // Extract primary symptoms
    if (answers.symptom_constellation?.selections) {
      symptoms.push(...answers.symptom_constellation.selections);
    }

    // Extract systemic symptoms
    if (answers.systemic_symptoms && Array.isArray(answers.systemic_symptoms)) {
      const systemicSymptoms = answers.systemic_symptoms.filter((s: string) => s !== "None of the above");
      symptoms.push(...systemicSymptoms);
    }
    return [...new Set(symptoms)].slice(0, 5); // Show max 5 symptoms
  };
  const getDuration = () => {
    if (!answers.symptom_constellation?.duration) return null;
    const durationMap: Record<string, string> = {
      "less_than_24_hours": "< 24hrs",
      "1_3_days": "1-3 days",
      "1_week": "1 week",
      "2_weeks": "2 weeks",
      "1_month": "1 month",
      "more_than_1_month": "> 1 month"
    };
    return durationMap[answers.symptom_constellation.duration] || answers.symptom_constellation.duration;
  };
  const getSeverity = () => {
    return answers.symptom_constellation?.severity;
  };
  const mainSymptoms = extractMainSymptoms();
  const duration = getDuration();
  const severity = getSeverity();
  if (mainSymptoms.length === 0) {
    return null;
  }
  return <Card className="p-4 bg-blue-50 border border-blue-200">
      <div className="flex items-center justify-between">
        <div className="flex items-center">
          <CheckCircle className="h-4 w-4 text-blue-600 mr-2" />
          <h3 className="text-sm font-medium text-gray-900">Your Symptoms Are....</h3>
        </div>
        {duration && <Badge variant="secondary" className="text-xs bg-blue-100 text-blue-700">
            {duration}
          </Badge>}
      </div>
      
      <div className="mt-3 flex flex-wrap gap-1">
        {mainSymptoms.map((symptom, idx) => <Badge key={idx} variant="outline" className="text-xs bg-white border-blue-200 text-blue-700">
            {symptom}
          </Badge>)}
        {severity && <Badge variant="outline" className={`text-xs ${severity <= 3 ? 'bg-green-50 border-green-200 text-green-700' : severity <= 6 ? 'bg-yellow-50 border-yellow-200 text-yellow-700' : 'bg-red-50 border-red-200 text-red-700'}`}>
            {severity}/10
          </Badge>}
      </div>
    </Card>;
};
export default SymptomsRecap;